import { GET_ORDER_PRODUCTS } from 'redux/modules/orders/actions/types';

import { fetchMultipleProducts } from 'redux/modules/products/actions/fetch-multiple-products';

export const fetchOrderProducts = fetchMultipleProducts(GET_ORDER_PRODUCTS);
